<div class="carousel">
  <div class="carousel__left" (click)="scrollLeft()" #btnLeft>
    <img src="assets/arrow.svg" width="512" height="512" alt="Arrow icon" />
  </div>
  <div class="carousel__right" (click)="scrollRight()" #btnRight>
    <img src="assets/arrow.svg" width="512" height="512" alt="Arrow icon" />
  </div>
  <div
    class="carousel__items"
    #carouselItems
    (mousedown)="startDrag($event)"
    (mousemove)="onDrag($event)"
    (mouseup)="stopDrag()"
    (mouseleave)="stopDrag()"
  >
    <ng-content />
  </div>
</div>
